export enum Features {
  videoConsultationTimeSlotsEnabled = 'ods-client-show-video-consultation-time-slots',
  providerPageWording = 'wsssh-265',
  questionnaireVisualization = 'wsssh-829',
  hideVideoJourney = 'wsssh-1561'
}

type FeatureDefaultsType = Record<Features, boolean>;
export const FeatureDefaults: FeatureDefaultsType = <FeatureDefaultsType>{};

FeatureDefaults[Features.videoConsultationTimeSlotsEnabled] = false;
FeatureDefaults[Features.providerPageWording] = false;
FeatureDefaults[Features.questionnaireVisualization] = false;
FeatureDefaults[Features.hideVideoJourney] = false;
